import { Button, Modal, Space, Typography, message } from "antd";
import { CopyOutlined, DownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const { Text, Paragraph } = Typography;

interface BackupCodesModalProps {
  open: boolean;
  codes: string[];
  onClose: () => void;
}

export const BackupCodesModal: React.FC<BackupCodesModalProps> = ({
  open,
  codes,
  onClose,
}) => {
  const { t } = useTranslation();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(codes.join("\n"));
      message.success("Copied!");
    } catch {
      message.error("Failed to copy");
    }
  };

  const handleDownload = () => {
    const content = `GoKids CRM - Backup Codes\n${"=".repeat(30)}\n\n${codes.join("\n")}\n\nEach code can only be used once.\nGenerated: ${new Date().toISOString()}`;
    const blob = new Blob([content], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "mfa-backup-codes.txt";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Modal
      title={t("auth.mfa.backupCodesTitle")}
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="close" type="primary" onClick={onClose}>
          {t("buttons.close")}
        </Button>,
      ]}
      maskClosable={false}
      width={440}
    >
      <Paragraph type="warning" style={{ marginBottom: 16 }}>
        {t("auth.mfa.backupCodesInfo")}
      </Paragraph>

      <div
        style={{
          background: "#ffffff",
          borderRadius: 8,
          padding: 16,
          marginBottom: 16,
          fontFamily: "monospace",
          fontSize: 16,
          lineHeight: 2,
          textAlign: "center",
        }}
      >
        {codes.map((code, i) => (
          <div key={i}>
            <Text code style={{ fontSize: 15, color: "rgba(0,0,0,0.88)" }}>
              {code}
            </Text>
          </div>
        ))}
      </div>

      <Space style={{ width: "100%", justifyContent: "center" }}>
        <Button icon={<CopyOutlined />} onClick={handleCopy}>
          {t("auth.mfa.copyAll")}
        </Button>
        <Button icon={<DownloadOutlined />} onClick={handleDownload}>
          {t("auth.mfa.download")}
        </Button>
      </Space>
    </Modal>
  );
};
